import { StyleSheet, Dimensions } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const SCREEN_WIDTH = Dimensions.get('window').width;
const style = StyleSheet.create({
  headline: {
    ...Fonts.type.bold,
    fontSize: 25,
    marginBottom: 5,
  },
  selectionTitle: {
    marginVertical: 19,
    fontSize: 19,
  },
  titleStyle: theme => ({
    color: theme.colors.text.text,
  }),
  subtitleStyle: theme => ({
    marginTop: 10,
    color: theme.colors.subtitle,
  }),
  optionContainer: {
    width: 108,
    height: 70,
    marginRight: 15,
  },
  halfWidthOption: {
    width: SCREEN_WIDTH / 2 - 30,
  },
  sectionOpacity: opacity => ({
    opacity,
  }),
});
export default style;
